// Getters (GET*)
// [CONTEXT]_[ACTION]_[PROPERTY]
export const FILTERS_GET_DATA = 'FILTERS_GET_DATA';
export const FILTERS_GET_PARAMS = 'FILTERS_GET_PARAMS';
export const FILTERS_GET_VALUES = 'FILTERS_GET_VALUES';
export const FILTERS_SHOULD_RELOAD = 'FILTERS_SHOULD_RELOAD';

// Mutations (SET*, ADD*, REMOVE*)
// [CONTEXT]_[ACTION]_[PROPERTY]
export const FILTERS_SET_VALUES = 'FILTERS_SET_VALUES';
export const FILTERS_SET_CONTROLS = 'FILTERS_SET_DATA';
export const FILTERS_SET_RELOAD = 'FILTERS_SET_RELOAD';

// Actions (FETCH*, CREATE*, UPDATE*, DELETE*, ANY*)
// [CONTEXT]_[ACTION]_[PROPERTY]_[STATUS]
export const FILTERS_RELOAD = 'FILTERS_RELOAD';
export const FILTERS_UPDATE_VALUES = 'FILTERS_UPDATE_VALUES';
export const FILTERS_UPDATE_CONTROLS = 'FILTERS_UPDATE_DATA';



// WEBPACK FOOTER //
// ./src/store/modules/filters/types.js